module.exports = __webpack_public_path__ + "media/images/lb/224-45085ab4c70f2eafa81a1f2c99034c37.svg";